import { render, staticRenderFns } from "./CourseViewerQuiz.vue?vue&type=template&id=4fc7fa5c&"
import script from "./CourseViewerQuiz.vue?vue&type=script&lang=js&"
export * from "./CourseViewerQuiz.vue?vue&type=script&lang=js&"
import style0 from "./CourseViewerQuiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports